export default __webpack_public_path__ + "static/media/pinterest.f6e08a0b.svg";